import { useInfiniteQuery } from '@tanstack/react-query';
import { RestEndpoints } from "../../../../api/endpoints";
import { ReactQueryConfig } from "../../../../config/react-query-config";
import getInstance from "../../../../utils/rest";
import { IAddressResult } from "../../../domain/address/address";
import { AddressConverter } from "../../../domain/converter/address.converter";
import { PaginationMetaConverter } from "../../../domain/converter/pagination-meta.converter";
import { IAddressResultModel } from "../../../models/address/address.model";
import { AddressType } from "./../../../models/address/address.model";
import { SharedQueryKeys } from "./../shared-query-keys";

const getInfiniteAddressesOfType = async (
  types: AddressType[],
  query: string | undefined,
  includeDeleted: boolean,
  pageParam: number = 0,
  pageSize: number = 5,
): Promise<IAddressResult> => {
  const response = await getInstance().get<IAddressResultModel>(RestEndpoints.Addresses, {
    params: {
      types,
      query,
      active: includeDeleted ? undefined : true,
      page: pageParam,
      pageSize,
    },
  });

  return {
    addresses: response.data.addresses.map(AddressConverter.toDomain),
    meta: PaginationMetaConverter.toDomain(response.data.meta),
  };
};

export const useGetInfiniteAddressesOfTypeQuery = (
  types: AddressType[],
  query: string | undefined,
  includeDeleted: boolean,
  pageSize?: number,
  enabled?: boolean,
) => {
  return useInfiniteQuery({
    queryKey: [SharedQueryKeys.GetInfiniteAddressesOfType, pageSize, query],
    queryFn: ({ pageParam }) => getInfiniteAddressesOfType(types, query, includeDeleted, pageParam as number, pageSize),
    getNextPageParam: (lastPage) => {
      const hasNextPage = lastPage.meta.page + 1 < lastPage.meta.numberOfPages;
      if (hasNextPage) {
        return lastPage.meta.page + 1;
      }

      return undefined;
    },
    initialPageParam: 0,
    staleTime: ReactQueryConfig.staleTime,
    enabled: enabled ?? true,
  });
};
